<template>
  <!-- 解决几个场景： 
  1. 根据外部的缴纳用途 变化 对应的值，并且选择对应项目，给父类反馈 目前已经选择的集合
  2. 根据已有的 选择项目 进行UI初始化，给父类反馈 目前已经选择的集合
  3. 支持设置是否可以点击改变Value（只读模式）

  从缓存读取时，避免因为 usage 的变化，重置了 用户手动选择的items，意味着除非是用户手动
  切换用途，否则用途对应的项目 不应该被改变/重置
  -->
  <div class="payment-item-container">
    <sby-block-select
      :name="pi.name"
      :value="pi.value"
      @change="itemToggle"
      :ref="'select-' + pi.value"
      :checked="selectedItems.includes(pi.value)"
      :hide="!canModify && !selectedItems.includes(pi.value)"
      :canModify="canModify"
      :rec="pi.value === 'ztax'"
      v-for="(pi, idx) in item_list"
      :tips="showDiscountsTips(pi)"
      :key="pi.value"
      :icon="icon"
    >
      <!-- <template v-slot:content><h4>高级: {{pi.name}}</h4></template> -->
    </sby-block-select>
    <div class="clear"></div>
  </div>
</template>

<script>
import _ from "lodash";
import { Toast, version , Dialog} from "vant";

export default {
  name: "sby-block-container",
  props: {
    value: {
      type: Array,
      // 对象或数组默认值必须从一个工厂函数获取
      default: function() {
        return [];
      }
    },
    icon: {
      type: String,
      default: ''
    },
    item_list: {
      type: Array,
      default: function() {
        return [];
      }
    },
    is_radio: {
      type: Boolean,
      default: false 
    },

    enable_discount: {
      type: Boolean,
      default: false 
    },
    min: {
      type: Number,
      default: 0 
    },
    item_refs: {
      type: Object
    },
    // 是否可以修改
    canModify: {
      type: Boolean,
      default: true
    }
  },
  model: {
    event: "change"
  },
  data() {
    return {
      selectedItems: this.value
    };
  },
  mounted() {

  },
  watch: {
    value(newSelectedItems) {
      this.selectedItems = newSelectedItems;
    }
  },
  methods: {
    itemToggle(selected, value) {
      this.$emit("change", this.buildSelectedItems(selected, value));
    },
    buildSelectedItems(selected, value) {
      let items = [...this.selectedItems];
      if (selected && !items.includes(value)) {
        // 单选 
        if (this.is_radio) {
          items = [value]
        } else {
          items.push(value);
        }

        // 自动选择关联项
        this.pushRefSelectedItems(items, selected, value);
      } else if (!selected && items.includes(value)) {
        _.remove(items, i => i === value);

        // 自动取消关联缴纳项
        this.removeRefSelectedItems(items, selected, value);
      }

      return items;
    },
    pushRefSelectedItems(items, selected, value) {
      let isTips = false;
      if (this.item_refs && this.item_refs[value]) {
        for (const name of this.item_refs[value].items) {
          if (!items.includes(name)) {
            items.push(name);
            isTips = true;
          }
        }
        for (const name of this.item_refs[value].conflictItems) {
          if (items.includes(name)) {
            _.remove(items, i => i === name); 
          }
        }
        if (isTips || (this.item_refs[value] && this.item_refs[value].selectedTips)) {
          let tips = isTips ? this.item_refs[value].tips : this.item_refs[value].selectedTips;
          if (!tips) {
            tips = this.item_refs[value].selectedTips;
          }
          if (tips) {
            Dialog.alert({message: tips, confirmButtonText: '了解了'});
          }
        }
        
      }
    },
    showDiscountsTips(item) {
      if (!this.enable_discount) {
        return "";
      }
      if (this.selectedItems.length == 0) {
        return "";
      }
      if (this.selectedItems.includes('gongjijin') && this.selectedItems.length === 1) {
        return "";
      }
      if (item.value === 'gongjijin' && !this.is_radio) {
        return "加我6折优惠";
      }
    },
    removeRefSelectedItems(items, selected, value) {
      if (this.item_refs) {
        for (const refKey in this.item_refs) {
          const itemRef = this.item_refs[refKey];
          if (itemRef.items.includes(value) && items.includes(refKey)) {
            _.remove(items, i => i === refKey);
          }
        }
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/sby-block-container.vue